var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 50,
    height: 50,
    rx: 25,
    fill: "#F2F4F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.6663 23.1663V27.7497C34.6663 32.333 32.833 34.1663 28.2497 34.1663H22.7497C18.1663 34.1663 16.333 32.333 16.333 27.7497V22.2497C16.333 17.6663 18.1663 15.833 22.7497 15.833H27.333",
    stroke: "#1D4ED8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6663 23.1663H30.9997C28.2497 23.1663 27.333 22.2497 27.333 19.4997V15.833L34.6663 23.1663Z",
    stroke: "#1D4ED8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9167 25.9167H26.4167",
    stroke: "#1D4ED8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9167 29.583H24.5834",
    stroke: "#1D4ED8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.35d8771889f290d5ee7ff54b4a618a1a.svg";
export { ForwardRef as ReactComponent };